import React, { DragEvent, ReactNode } from "react";

interface Props {
  children: ReactNode;
  className?: string;
  passRef?: React.Ref<HTMLLIElement>;
  style?: React.CSSProperties;
  onDragStart?: (e: DragEvent) => void;
}

export const ListItem: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  passRef,
  style,
  onDragStart,
}) => (
  <li
    onDragStart={onDragStart}
    className={className}
    ref={passRef}
    style={style}
  >
    {children}
  </li>
);
